"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWorkspaceLogoUrlRequestF = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var storage_1 = require("firebase/storage");
var actions_1 = require("../../constants/actions");
var getWorkspaceLogoStoragePath_1 = require("../../utilities/get/getWorkspaceLogoStoragePath");
var storage_2 = require("firebase/storage");
var getWorkspaceLogoUrlRequestF = function () {
    var action, requestValues, workspaceId, storageRef, thumbPath, uploadRef, downloadUrl;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!1) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, effects_1.take)([
                        actions_1.GET_WORKSPACE_LOGO_URL_REQUEST,
                    ])];
            case 1:
                action = _a.sent();
                requestValues = action.requestValues;
                workspaceId = requestValues.workspaceId;
                storageRef = (0, storage_2.ref)((0, storage_1.getStorage)());
                thumbPath = (0, getWorkspaceLogoStoragePath_1.getWorkspaceLogoStoragePath)({ workspaceId: workspaceId }).thumbPath;
                uploadRef = (0, storage_2.ref)(storageRef, thumbPath);
                return [4 /*yield*/, (0, storage_2.getDownloadURL)(uploadRef)];
            case 2:
                downloadUrl = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)({
                        type: 'GET_WORKSPACE_LOGO_URL_SUCCESS',
                        description: 'getWorkspaceLogoUrlRequestF',
                        requestValues: requestValues,
                        successValues: {
                            logoUrl: downloadUrl,
                        },
                    })];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
exports.getWorkspaceLogoUrlRequestF = getWorkspaceLogoUrlRequestF;
